import axios from 'axios';
import { storeGetters } from '../../storeGetters.constant';
import { storeAction } from '../../storeActions.constant';
import {getBasicHeaders, getHeadersWithFormData} from '../../../common/utils/utils';
import { storeMutation } from '../../storeMutations.constant';

export const fileDragDropState = {
    fileUploadPercentage: 10,
};
export const fileDragDropMutations = {};
export const fileDragDropActions = {
    [storeAction.uploadFiles]: async ({ state, commit, rootGetters }, formData) => {
        formData.append('CommunityId', await rootGetters[storeGetters.communityIdPromise]);
        return axios({
            url: `${state.baseURL}communities/api/communities/upload-files/${rootGetters[storeGetters.communityName]}`,
            headers: getHeadersWithFormData(),
            data: formData,
            method: 'POST',
            onUploadProgress: (progressEvent) => {
                const val = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
                state.fileUploadPercentage = val > 10 ? val - 10 : val;
            },
        })
            .then((response) => {
                commit(storeMutation.updateFilesAndMediaList, response.data);
                state.fileUploadPercentage = 0;
                return true;
            })
            .catch((err) => {
                console.log(err);
                state.fileUploadPercentage = 0;
                throw err;
            });
    },
};
export const fileDragDropGetters = {
    [storeGetters.fileUploadPercentage]: (state) => state.fileUploadPercentage,
};
